import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
Vue.use(VueRouter)



// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
// 	return originalPush.call(this, location).catch((err) => err);
// }


const routes = [{
		path: '/',
		name: 'index',
		component: () => import('../views/index.vue'),
		children: [{
				path: '/home',
				component: () => import('../views/home.vue'),
				meta: {
					keepAlive: true // 需要缓存
				}
			}, {
				path: '/corporateImage',
				component: () => import('../views/corporateImage.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/positionManagement',
				component: () => import('../views/positionManagement.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/messageManagement',
				component: () => import('../views/messageManagement.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/messageSearch',
				component: () => import('../views/messageSearch.vue'),
				meta: {
					keepAlive: false
				}
			}, {
				path: '/resumeDownload',
				component: () => import('../views/resumeDownload.vue'),
				meta: {
					keepAlive: false
				}
			}, {
				path: '/resumeRecharge',
				component: () => import('../views/resumeRecharge.vue'),
				meta: {
					keepAlive: false
				}
			}, {
				path: '/pdfpreview',
				name: 'pdfpreview',
				component: () => import('../views/previewResumePdf.vue'),
				meta: {
					keepAlive: false
				}
			}, {
				path: '/personalCenter',
				component: () => import('../views/personalCenter.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/systemSettings',
				component: () => import('../views/systemSettings.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/jobDetails',
				component: () => import('../views/jobDetails.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/addPosition',
				component: () => import('../views/addPosition.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/commentManagement',
				component: () => import('../views/commentManagement.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/liveManagement',
				component: () => import('../views/liveManagement.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/pushMessage',
				component: () => import('../views/pushMessage.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/accountManagement',
				component: () => import('../views/accountManagement.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/meeting',
				component: () => import('../views/meeting.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/activityIntroduction',
				component: () => import('../views/activityIntroduction.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}, {
				path: '/signup',
				component: () => import('../views/signup.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/reglist',
				component: () => import('../views/reglist.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/communityPromotion',
				component: () => import('../views/communityPromotion.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/switchAccount',
				component: () => import('../views/switchAccount.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/jobShadowing',
				component: () => import('../views/jobShadowing.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/wednesday',
				component: () => import('../views/wednesday.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/cooperation',
				component: () => import('../views/cooperation.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/meetingDemo',
				component: () => import('../views/meetingDemo.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/corporateApply',
				component: () => import('../views/corporateApply.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			},
			{
				path: '/invoiceList',
				component: () => import('../views/invoiceList.vue'),
				meta: {
					keepAlive: false // 不需要缓存
				}
			}
		],

	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login.vue'),
		children: [
			// // 登录主体
			// { path: '/', component: ()=>import('../components/login/Logins.vue') }
		]
	}, {
		path: '/register',
		name: 'register',
		component: () => import('../views/register.vue'),
		children: [
			// // 登录主体
			// { path: '/', component: ()=>import('../components/login/Logins.vue') }
		]
	}, {
		path: '/forgetPassword',
		name: 'forgetPassword',
		component: () => import('../views/forgetPassword.vue'),
		children: [
			// // 登录主体
			// { path: '/', component: ()=>import('../components/login/Logins.vue') }
		]
	}, {
		path: '/privacy',
		name: 'privacy',
		component: () => import('../views/privacy.vue'),
		children: [
			// // 登录主体
			// { path: '/', component: ()=>import('../components/login/Logins.vue') }
		]
	}
]



const router = new VueRouter({
	mode: 'history',
	// base: process.env.BASE_URL,
	base: '/',
	routes,
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

function clearLoginInfo() {
	store.commit('setIslogin', false)
	store.commit('setAdminId', '')
	store.commit('setUserInfo', '')
	store.commit('setSchoolData', '')
	store.commit('setUserId', '')
	store.commit('setToken', '')

	localStorage.removeItem('isLogin')
	localStorage.removeItem('user_id')
	localStorage.removeItem('userInfo')
	localStorage.removeItem('schoolData')
	localStorage.removeItem('admin_id')
	localStorage.removeItem('nextToken')
}

router.beforeEach((to, from, next) => {
	console.log(window.previousPath)
	window.previousPath = from.fullPath;

	let admin_id = localStorage.getItem('admin_id')
	let user_id = localStorage.getItem('user_id')
	let nextToken = localStorage.getItem('nextToken')

	let isAdminId = (admin_id && admin_id != 'null')
	let isUserId = (user_id && user_id != 'null')


	if (to.path == '/register' || to.path == '/login') {
		next()
	} else {
		if (isAdminId || (!isAdminId && !isUserId)) {
			if (to.path === '/signup') {
				let meetObj = sessionStorage.getItem('meetObj')
				let selectMeetList = sessionStorage.getItem('selectMeetList')
				if (meetObj || selectMeetList) {
					return next()
				} else {
					if (to.path !== '/meeting') {
						return next('/meeting')
					}
				}
			} else if (to.path === '/') {
				return next({
					path: '/home',
					replace: true
				})
			} else if (to.path === '/login') {
				if ((admin_id && admin_id != 'null') && (user_id && user_id != 'null')) {
					return next('/home');
				} else {
					return next();
				}
			} else {
				return next()
			}
		} else {
			if (to.path === '/meeting' && nextToken && !isAdminId && isUserId) {
				clearLoginInfo()
				return next()
			}
			return next({
				path: '/register',
				replace: true
			})
		}
	}






	// if ((admin_id && admin_id != 'null') && (user_id && user_id != 'null')) {
	// 	if (to.path === '/') {
	// 		next('/home');
	// 	} else if (to.path === '/register') {
	// 		next('/home');
	// 	} else if (to.path === '/signup') {
	// 		let meetObj = sessionStorage.getItem('meetObj')
	// 		let selectMeetList = sessionStorage.getItem('selectMeetList')
	// 		if (meetObj || selectMeetList) {
	// 			next()
	// 		} else {
	// 			next('/meeting')
	// 		}
	// 	} else {
	// 		next()
	// 	}
	// } else {
	// 	if (to.path === '/login' || to.path === '/forgetPassword') {
	// 		next()
	// 	} else if (to.path === '/register') {
	// 		next()
	// 	} else if (to.path === '/privacy') {
	// 		next()
	// 	} else if (to.path === '/meeting') {
	// 		next()
	// 	} else {
	// 		next('/login')
	// 	}
	// }

})
// 保存原push方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 只忽略重复导航错误，其他异常正常抛出
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

// 同理修复replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}
export default router
